import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '../../components/Pleri/components/Settings/SettingsLayout';
import { ActivityList } from '../../components/Pleri/components/Activity/ActivityList';

export const Route = createFileRoute('/settings/activities')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SettingsLayout>
      <ActivityList />
    </SettingsLayout>
  );
}
